module.exports = __webpack_public_path__ + "static/dg1-e8be2ef0cb4eb53d122d0835c501d0c9.jpg";